import { SuggesterCallbacksRegistry, suggestPlugin, } from "../../core/suggest/suggest-plugin";
import { SlashCommandGroup } from "../../core/types";
import { Extension } from "../../core/extension";
import { EmojiSuggesterPluginView } from "./components/EmojiSuggesterPluginView/EmojiSuggesterPluginView";
import { createEmoji, startEmojiSuggester } from "./commands";
import { emojiSuggesterMatchOffsetPlugin } from "./plugins";
export class EmojiExtension extends Extension {
    constructor() {
        super(...arguments);
        this.suggesterRegistry = new SuggesterCallbacksRegistry();
    }
    addPlugins(schema, plugins, { portalContainer }) {
        return plugins.concat([
            suggestPlugin(portalContainer, this.suggesterRegistry, EmojiSuggesterPluginView, {}),
            emojiSuggesterMatchOffsetPlugin(),
        ]);
    }
    addSuggesters(suggesters) {
        return [
            ...suggesters,
            {
                name: "emoji-suggestion",
                noDecorations: true,
                char: ":",
                supportedCharacters: /\w+/,
                createCommand: ({ match, view }) => {
                    return (emoji) => {
                        createEmoji(view, emoji, match.range.from, match.range.to);
                    };
                },
                ...this.suggesterRegistry.callbacks,
            },
        ];
    }
    addSlashCommands(commands) {
        return [
            ...commands,
            {
                label: `Insert Emoji`,
                description: `Use emojis to express emotions`,
                group: SlashCommandGroup.Basics,
                icon: "smiley",
                command: (match, view) => {
                    startEmojiSuggester(view, match.range.from, match.range.to);
                },
            },
        ];
    }
}
